import { DatePipe } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonDropdownSearchComponent } from '../common-component-dropdown-search/common-component-dropdown-search.component';
import { CommonSearchComponent } from '../common-component-search/common-component-search.component';
import { CommonApiService } from '../CommonController/common-api-service';
import { OtaApiService } from '../CommonController/ota-api-service';
import { SharedValidators } from '../shared/validators/shared-validators';
@Component({
  selector: 'app-ota-batch-create',
  templateUrl: './ota-batch-create.component.html',
  styleUrls: ['./ota-batch-create.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatIcon,
    MatFormField,
    MatLabel,
    MatInput,
    MatError,
    MatCheckboxModule,
    CommonDropdownSearchComponent,
    CommonSearchComponent,
  ],
})
export class OtaBatchCreateComponent implements OnInit {
  @ViewChild('otaDeviceFile') otaDeviceFile: ElementRef;
  config = false;
  paraArr = [];
  checkedArr = [];
  otaListSelected = [];
  totalItems = 0;
  currentPage = 1;
  pageSize = 10;
  ParametersListForm: FormGroup;
  CommondForm: FormGroup;
  formGroup: FormGroup;
  imei = '';
  public totalPages;
  commandArray = [];

  searchForm: FormGroup;
  otaTypeList = [
    { key: 'ALL', value: '' },
    { key: 'GET', value: 'GET' },
    { key: 'SET', value: 'SET' },
    { key: 'CLR', value: 'CLR' },
  ];
  searchString = '';
  otaCommandType = '';

  deleteOta = false;
  viewOta = false;
  createOta = false;
  updateOta = false;
  userPermissions = [];

  constructor(
    public router: Router,
    private formBuilder: FormBuilder,
    public datepipe: DatePipe,
    private spinner: NgxSpinnerService,
    public commonApiService: CommonApiService,
    public otaApiService: OtaApiService
  ) {}

  ngOnInit(): void {
    this.checkPermission();
    this.spinner.show();
    this.imei = sessionStorage.getItem('imei');
    if (this.imei === null) {
      this.imei = '';
    }
    this.paraArr = [];
    sessionStorage.setItem('batchType', 'Set');
    this.setOtaBatchForm();
    this.fetchOtaMaster();
  }

  checkPermission() {
    this.userPermissions = JSON.parse(
      sessionStorage.getItem('userPermissions')
    );
    this.userPermissions.forEach((element) => {
      if (element.pageName === 'Ota' && element.view === false) {
        this.navigateBack();
      }
      if (element.pageName === 'Ota' && element.view === true) {
        this.viewOta = true;
      }
      if (element.pageName === 'Ota' && element.create === true) {
        this.createOta = true;
      }
      if (element.pageName === 'Ota' && element.update === true) {
        this.updateOta = true;
      }
      if (element.pageName === 'Ota' && element.delete === true) {
        this.deleteOta = true;
      }
    });
  }

  setOtaBatchForm() {
    this.ParametersListForm = this.formBuilder.group({
      batchName: new FormControl('', [
        SharedValidators.requiredAndNoEmptySpaces,
      ]),
      batchDescription: new FormControl('', [
        SharedValidators.requiredAndNoEmptySpaces,
      ]),
      fileName: new FormControl(''),
    });

    this.searchForm = this.formBuilder.group({
      OTAType: new FormControl(''),
      searchInput: new FormControl(''),
    });
  }

  public calculateTotalPages(): void {
    this.totalPages = Math.ceil(this.paraArr.length / this.pageSize);
  }

  public getPaginatedItems() {
    const startIndex = (this.currentPage - 1) * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    return this.paraArr.slice(startIndex, endIndex);
  }

  changePage(currentPage) {
    if (currentPage >= 1 && currentPage <= this.getTotalPages()) {
      this.currentPage = currentPage;
      this.otaListSelected = this.getPaginatedItems();
    }
  }

  getTotalPages() {
    return Math.ceil(this.paraArr.length / this.pageSize);
  }

  //add this onFileSelected, convertCSVtoJSON, processCSVData  below 3 method replace for convert method
  onFileSelected(ev) {
    try {
      if (ev.target.files && ev.target.files.length > 0) {
        const file = ev.target.files[0];

        if (file.name.endsWith('.csv')) {
          this.ParametersListForm.get('fileName').setValue(file.name);
        } else {
          this.commonApiService.openSnackbar('Please upload a valid CSV file');
        }
      } else {
        this.ParametersListForm.get('fileName').setValue('');
      }
    } catch (error) {
      this.commonApiService.openSnackbar(
        error.error.message || 'Please upload a valid CSV file'
      );
      this.ParametersListForm.get('fileName').setValue('');
    }
  }

  configselection() {
    this.config = true;
    document.getElementById('table').scrollIntoView();
  }

  downloadMyFile(): void {
    if (confirm('Are You Sure?')) {
      const link: HTMLAnchorElement = document.createElement('a');
      link.setAttribute('target', '_blank');
      link.setAttribute('href', '../../assets/SampleOTATemplate.csv');
      link.setAttribute('download', 'SampleOTATemplate.csv');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link); // Remove the link after the download is complete
    }
  }

  submit() {
    const file = this.otaDeviceFile.nativeElement.files[0];
    if (file) {
      Object.keys(this.CommondForm.controls).forEach((key) => {
        const item = this.otaListSelected.find(
          (fItem) => fItem.id.toString() === key
        );
        if (item) {
          const modifiedCommand = item.otaCommand.trim(); // Remove unwanted spaces

          if (
            modifiedCommand.includes('VAL') &&
            this.CommondForm.controls[key].value !== null &&
            this.CommondForm.controls[key].value !== ''
          ) {
            if (/^[0-9]+$/.test(this.CommondForm.controls[key].value)) {
              this.CommondForm.controls[key].setValue(
                modifiedCommand.replace(
                  'VAL',
                  String(this.CommondForm.controls[key].value)
                )
              );
            }
          } else if (
            modifiedCommand.includes('VAL') &&
            (this.CommondForm.controls[key].value === null ||
              this.CommondForm.controls[key].value === '')
          ) {
            this.CommondForm.markAllAsTouched();
          } else {
            this.CommondForm.controls[key].setValue(modifiedCommand);
          }
        }
      });

      this.CommondForm.updateValueAndValidity();

      if (this.CommondForm.valid) {
        const payload = {
          batchName: '',
          batchDescription: '',
          commandList: '',
          userId: '',
        };
        if (this.ParametersListForm.invalid) {
          this.ParametersListForm.controls['batchName'].markAsTouched();
          this.ParametersListForm.controls['batchDescription'].markAsTouched();
          return;
        } else {
          payload.batchName =
            this.ParametersListForm.controls['batchName'].value;
          payload.batchDescription =
            this.ParametersListForm.controls['batchDescription'].value;
        }

        if (window.confirm('Are you sure you want to submit the form?')) {
          payload.commandList = JSON.stringify(this.CommondForm.value);
          payload.userId = sessionStorage.getItem('loggedInUserId');
          this.spinner.show('loading');
          this.otaApiService.uploadOtaBatch(file, payload).subscribe({
            next: (res) => {
              try {
                if (res.status) {
                  this.spinner.show('loading');
                } else {
                  this.spinner.hide('loading');
                  this.commonApiService.openSnackbar('Something went wrong');
                }
              } catch (error) {
                this.spinner.hide('loading');
                this.commonApiService.openSnackbar(
                  error.error.message ||
                    'An error occurred while processing the data.'
                );
              }
            },
            error: (err) => {
              this.spinner.hide('loading');
              this.commonApiService.openSnackbar(err.error.message);
            },
            complete: () => {
              setTimeout(() => {
                this.spinner.hide('loading');
                this.router.navigate(['/ota-batch-page']);
              }, 4000);
            },
          });
        } else {
          this.commonApiService.openSnackbar('Form submission canceled.');
        }
      } else {
        this.CommondForm.markAllAsTouched();
        this.commonApiService.openSnackbar(
          'Please give input to all selected commonds to submit the batch.'
        );
      }
    } else {
      this.commonApiService.openSnackbar('Please select the file');
    }
  }

  SubmitBatch() {
    // document.getElementById("table").scrollIntoView();
    const CommondFormValue = this.CommondForm?.value || {};
    this.paraArr = [];
    this.checkedArr.forEach((element) => {
      this.paraArr.push({
        otaCommand: element.otaCommand,
        name: element.name,
        inputRequired: element.inputRequired,
        example: element.otaCommandExample,
        id: element.id,
      });
    });
    const formGroupObject = {};

    this.paraArr.forEach((elm) => {
      if (elm.inputRequired === 'YES') {
        formGroupObject[elm.id] = new FormControl(CommondFormValue[elm.id], [
          SharedValidators.requiredAndNoEmptySpaces,
        ]);
      } else {
        formGroupObject[elm.id] = new FormControl(CommondFormValue[elm.id]);
      }
    });
    this.CommondForm = this.formBuilder.group(formGroupObject);
    this.totalItems = this.paraArr.length;
    this.config = true;
    this.otaListSelected = this.paraArr;
    // this.otaListSelected = this.getPaginatedItems();
  }

  deleteCommand(id) {
    this.paraArr = this.paraArr.filter((item) => item.id !== id);
    this.checkedArr = this.checkedArr.filter((item) => item.id !== id);
    if (this.paraArr.length === 0) {
      this.config = false;
    }
    this.SubmitBatch();
    this.getPaginatedItems();
  }
  clearCommand(otaCommand) {
    this.CommondForm.controls[otaCommand].setValue('');
  }

  fetchOtaMaster() {
    this.spinner.show();
    this.otaApiService
      .getOtaCommandList(0, 1000, this.otaCommandType, this.searchString)
      .subscribe(
        (res) => {
          this.commandArray = res.data;
          this.spinner.hide();
        },
        (err) => {
          this.commonApiService.openSnackbar(err.error.message);
          this.commandArray = [];
          this.spinner.hide();
        }
      );
  }

  addToCheckedArray(event, item) {
    if (event.checked) {
      this.checkedArr.push(item);
    } else {
      const index = this.checkedArr.findIndex((obj) => obj === item);
      if (index !== -1) {
        this.checkedArr.splice(index, 1);
      }
    }
  }

  checkChecked(item) {
    for (const checkedItem of this.checkedArr) {
      if (item.id === checkedItem.id) {
        return true;
      }
    }
    return false;
  }

  navigateBack() {
    this.commonApiService.back();
  }

  redirect(to): void {
    this.router.navigate([to]);
  }

  onSearch(event) {
    console.log('Search event:', event);
    this.searchForm.get('searchInput').setValue(event);
    this.searchString = event;
    this.fetchOtaMaster();
  }

  onStatusSelect(event): void {
    this.otaCommandType = event;
    this.searchForm.get('OTAType')?.setValue(event);
    this.fetchOtaMaster();
  }
}
